export default class Unauthorized extends Error {
  /**
   * 驗證失敗
   */
  constructor(data) {
    super(JSON.stringify(data));
    this.name = 'Unauthorized';
    this.StatusCode = 401;
    this.data = data;
  }
}
